import React from 'react'
import {withRouter} from "react-router";
import { connect } from 'react-redux';
import LoginPage  from '../components/LoginPage';
import App from './App'

class CheckAuth extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (!this.props.isLoggedIn && this.props.location.pathname.includes('hash-login')) {
            return <App />
        }

        //jeśli klient niezalogowany to pokazujemy stronę logowania
        if (!this.props.isLoggedIn) {
            return <LoginPage />
        }
        return <App />
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.user.isLoggedIn,
    };
};


export default connect(mapStateToProps, null)(withRouter(CheckAuth));
